import { Injectable } from '@angular/core';
/**
 * An abstract base class that implements
 * the Internationalization service methods
 * for the current locale.
 */
var IntlService = (function () {
    function IntlService() {
    }
    return IntlService;
}());
export { IntlService };
IntlService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
IntlService.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-intl/dist/es/intl.service.js
// module id = ../../../../@progress/kendo-angular-intl/dist/es/intl.service.js
// module chunks = 3